// Utility to map backend status enums to user-friendly status names and color palette
export function getStatusDisplay(status) {
  const statusMap = {
    'TXN_SUCCESS': { label: 'Success', backgroundColor: '#36B37E33', color: '#00875A' },
    'TXN_PENDING': { label: 'Pending', backgroundColor: '#FFBF0033', color: '#FFBF00' },
    'TXN_FAILURE': { label: 'Failed', backgroundColor: '#FF4D4D33', color: '#FF4D4D' },
    'TXN_REJECTED': { label: 'Rejected', backgroundColor: '#FF4D4D33', color: '#FF4D4D' },
    'TXN_CANCELLED': { label: 'Cancelled', backgroundColor: '#6C757D33', color: '#6C757D' },
    'TXN_REFUNDED': { label: 'Refunded', backgroundColor: '#17A2B833', color: '#17A2B8' },
    'TXN_PROCESSING': { label: 'Processing', backgroundColor: '#FFBF0033', color: '#FFBF00' },
    'TXN_INITIATED': { label: 'Initiated', backgroundColor: '#FFBF0033', color: '#FFBF00' },
    'TXN_UNKNOWN': { label: 'Unknown', backgroundColor: '#F0F0F0', color: '#000000' },
    'UNKNOWN': { label: 'Unknown', backgroundColor: '#F0F0F0', color: '#000000' },
    // Fallback for any other status
    'default': { label: status || 'Unknown', backgroundColor: '#F0F0F0', color: '#000000' }
  };
  return statusMap[status] || statusMap['default'];
} 